import FileWithContext from '../../models/file_with_context'
import InvalidEnum from '../invalid_enum'

class InvalidCategory extends InvalidEnum {
  constructor(value) {
    super(value, 'category', Object.values(FileWithContext.CATEGORY))
  }
}

export default InvalidCategory
